import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutStephane from '../components/AboutStephane';
import ServicesSection from '../components/ServicesSection';
import ContactSection from '../components/ContactSection';
import SEO from '../components/SEO';
import { PAGES_SEO } from '../seo/pagesSeo';
import ObjetsPage from "../components/ObjetsPage";
import debarrassageImage from '../images/avant-apres-debarras.PNG';

function DetailsSection() {
    const features = [
        {
            title: "Service Complet",
            description: "Je propose un service complet de débarras de maison, que ce soit après un décès, un départ à la retraite ou toute autre situation nécessitant de vider un lieu."
        },
        {
            title: "Débarras Gratuit",
            description: "Ce service peut être entièrement gratuit si des antiquités ou objets de valeur sont récupérés. En évaluant correctement les biens, je réduis voire annule les frais de débarras."
        },
        {
            title: "Accompagnement Professionnel",
            description: "Mon objectif est de vous accompagner avec professionnalisme tout en vous permettant de récupérer une partie de la valeur des biens que vous souhaitez vendre."
        }
    ];

    return (
        <section className="details-section">
            <div className="section-container">

                <div className="content-layout">
                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card">
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="right-column">
                        <div className="intro-section">
                            <h2>Débarras et Succession</h2>
                            <p className="section-subtitle">
                                En tant qu'antiquaire expert, je ne me contente pas uniquement de racheter des objets anciens et des antiquités.
                            </p>
                        </div>
                        
                        <div className="image-showcase">
                            <div className="image-card">
                                <img src={debarrassageImage} alt="Avant et après un débarras" />
                                <div className="image-overlay">
                                    <span>Avant / Après</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cta-section">
                    <a href="tel:0658084516" className="cta-button">
                        06 58 08 45 16
                    </a>
                </div>
            </div>

            <style jsx>{`
                .details-section {
                    background: linear-gradient(135deg, #f2f5f7 0%, #e8ecef 100%);
                    padding: 80px 24px;
                    position: relative;
                }

                .section-container {
                    max-width: 1200px;
                    margin: 0 auto;
                }

                .section-header {
                    text-align: center;
                    margin-bottom: 64px;
                }

                .section-header h2 {
                    font-size: 3rem;
                    line-height: 1.1;
                    margin: 0 0 16px;
                    color: #1f2b2a;
                    letter-spacing: -0.02em;
                }

                .section-subtitle {
                    font-size: 1.25rem;
                    line-height: 1.6;
                    color: #44504f;
                    max-width: 700px;
                    margin: 0 auto;
                }

                .content-layout {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 64px;
                    align-items: start;
                    margin-bottom: 64px;
                }

                .right-column {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                }

                .intro-section h2 {
                    font-size: 3rem;
                    line-height: 1.1;
                    margin: 0 0 16px;
                    color: #1f2b2a;
                    letter-spacing: -0.02em;
                }

                .intro-section .section-subtitle {
                    font-size: 1.25rem;
                    line-height: 1.6;
                    color: #44504f;
                    margin: 0;
                }

                .image-showcase {
                    display: flex;
                    justify-content: center;
                }

                .image-card {
                    position: relative;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 12px 40px rgba(0,0,0,0.15);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    max-width: 500px;
                    width: 100%;
                }

                .image-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
                }

                .image-card img {
                    width: 100%;
                    height: auto;
                    display: block;
                }

                .image-overlay {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: linear-gradient(transparent, rgba(0,0,0,0.8));
                    padding: 24px;
                    color: white;
                }

                .image-overlay span {
                    font-size: 1.1rem;
                    font-weight: 600;
                    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
                }

                .features-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .feature-card {
                    background: #fff;
                    border-radius: 16px;
                    padding: 28px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    border-left: 4px solid #C0A26B;
                }

                .feature-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                    border-left-color: #20453d;
                }

                .feature-card h3 {
                    font-size: 1.4rem;
                    color: #1f2b2a;
                    margin: 0 0 12px;
                    font-weight: 600;
                }

                .feature-card p {
                    font-size: 1.05rem;
                    line-height: 1.6;
                    color: #44504f;
                    margin: 0;
                }

                .cta-section {
                    text-align: center;
                }

                .cta-button {
                    display: inline-block;
                    background: linear-gradient(135deg, #C0A26B 0%, #d4b875 100%);
                    color: #20453d;
                    padding: 18px 36px;
                    text-decoration: none;
                    border-radius: 30px;
                    font-weight: 700;
                    font-size: 1.2rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 6px 24px rgba(192, 162, 107, 0.4);
                    position: relative;
                    overflow: hidden;
                }

                .cta-button::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
                    transition: left 0.6s ease;
                }

                .cta-button:hover::before {
                    left: 100%;
                }

                .cta-button:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 32px rgba(192, 162, 107, 0.5);
                    background: linear-gradient(135deg, #d4b875 0%, #C0A26B 100%);
                }

                @media (max-width: 1024px) {
                    .content-layout {
                        grid-template-columns: 1fr;
                        gap: 48px;
                    }

                    .intro-section h2 {
                        font-size: 2.5rem;
                    }
                }

                @media (max-width: 768px) {
                    .details-section {
                        padding: 60px 20px;
                    }

                    .intro-section h2 {
                        font-size: 2.2rem;
                    }

                    .intro-section .section-subtitle {
                        font-size: 1.1rem;
                    }

                    .content-layout {
                        gap: 32px;
                        margin-bottom: 48px;
                    }

                    .feature-card {
                        padding: 24px;
                    }

                    .feature-card h3 {
                        font-size: 1.2rem;
                    }

                    .cta-button {
                        padding: 15px 28px;
                        font-size: 1.1rem;
                    }
                }
            `}</style>
        </section>
    );
}

function HomePage() {
    const seo = PAGES_SEO.home;
    return (
        <div className="homepage">
            <SEO title={seo.title} description={seo.description} path={seo.path} />
            
            <main className="main-content">
                <HeroSection />
                <div className="content-flow">
                    <AboutStephane />
                    <ObjetsPage />
                    <DetailsSection />
                    <ServicesSection />
                    <ContactSection />
                </div>
            </main>

            <style jsx>{`
                .homepage {
                    min-height: 100vh;
                    background: #fff;
                }

                .main-content {
                    position: relative;
                    overflow-x: hidden;
                }

                .content-flow {
                    position: relative;
                }

                .content-flow > :global(section) {
                    position: relative;
                    z-index: 1;
                }

                .content-flow > :global(section:nth-child(even)) {
                    background: #f8fafb;
                }

                .content-flow > :global(section:nth-child(odd)) {
                    background: #fff;
                }

                .content-flow::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 2px;
                    height: 100%;
                    background: linear-gradient(to bottom, transparent 0%, #C0A26B 20%, #C0A26B 80%, transparent 100%);
                    z-index: 0;
                    opacity: 0.3;
                }

                @media (max-width: 768px) {
                    .content-flow::before {
                        display: none;
                    }
                }
            `}</style>
        </div>
    );
}

export default HomePage;
